/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_List_DirInputs */

const es_tools_legajox_list_dir = /** @type {(inputs: Tools_Legajox_List_DirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listando carpetas de Legajox...`)
};

const en_tools_legajox_list_dir = /** @type {(inputs: Tools_Legajox_List_DirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Legajox folders...`)
};

/**
* | output |
* | --- |
* | "Listing Legajox folders..." |
*
* @param {Tools_Legajox_List_DirInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_list_dir = /** @type {((inputs?: Tools_Legajox_List_DirInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_List_DirInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_list_dir(inputs)
	return en_tools_legajox_list_dir(inputs)
});
export { tools_legajox_list_dir as "tools.legajox.list_dir" }